module.exports = __webpack_public_path__ + "img/api_settings.2d9a4999.svg";